import { Tooltip } from "@mui/material";
import { FC } from "react";
import { useTranslation } from "react-i18next";
import { makeStyles } from "tss-react/mui";
import { LoginAsIcon } from "../Primitives/Icons";

const useStyles = makeStyles()(() => ({
  // The icon is a plain function component, so the tooltip needs a ref-holding element to anchor to.
  anchor: {
    display: "inline-flex",
    verticalAlign: "middle",
  },
}));

interface IHasLoginIndicatorProps {
  hasLogin: boolean | undefined;
  className?: string;
}

/** Marks a user that can be a login-as target; renders nothing otherwise. */
export const HasLoginIndicator: FC<IHasLoginIndicatorProps> = ({ hasLogin, className }) => {
  const { t } = useTranslation();
  const { classes, cx } = useStyles();

  if (hasLogin !== true) {
    return null;
  }

  const label = t("basedata.users.table.hasLogin");
  return (
    <Tooltip title={label}>
      <span className={cx(classes.anchor, className)} aria-label={label} data-testid="has-login-indicator">
        <LoginAsIcon fontSize="small" />
      </span>
    </Tooltip>
  );
};
